/* global axios */
import ApiClient from './ApiClient';

class CommercialQuotesAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  quoteUrl(dealId, quoteId) {
    const base = `${this.url}/${dealId}/commercial_quotes`;
    return quoteId ? `${base}/${quoteId}` : base;
  }

  list(dealId) {
    return axios.get(this.quoteUrl(dealId));
  }

  save(dealId, quote) {
    const payload = { commercial_quote: quote };
    return quote.id
      ? axios.patch(this.quoteUrl(dealId, quote.id), payload)
      : axios.post(this.quoteUrl(dealId), payload);
  }

  remove(dealId, quoteId) {
    return axios.delete(this.quoteUrl(dealId, quoteId));
  }

  action(dealId, quoteId, action) {
    return axios.post(`${this.quoteUrl(dealId, quoteId)}/${action}`);
  }
}

export default new CommercialQuotesAPI();
